import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import Datetime from "react-datetime";
import moment from "moment";

import TablePagination from "@material-ui/core/TablePagination";
import { lighten, makeStyles } from "@material-ui/core/styles";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableContainer from "@material-ui/core/TableContainer";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import AddAlert from "@material-ui/icons/AddAlert";
import Checkbox from "@material-ui/core/Checkbox";
import TableRow from "@material-ui/core/TableRow";
import Toolbar from "@material-ui/core/Toolbar";
import Table from "@material-ui/core/Table";
import Card from "components/Card/Card.js";
import List from "@material-ui/icons/List";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
// core components
import { PAGINATION_DETAILS, PAGE_SIZES, API_BASE_URL, CSV_DATE_FORMAT } from "../../common/constants";
import styles from "assets/jss/material-dashboard-pro-react/views/userStyle.js";
import {DELETE_ERROR_LOG_DATA_REQUEST} from "../../redux/device/actions";
import GridContainer from "components/Grid/GridContainer.js";
import { useComposeDispatcher } from "../../common/hooks";
import NewFiltersBox from "views/FilterBox/NewFiltersBox";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import CardHeader from "components/Card/CardHeader.js";
import GridItem from "components/Grid/GridItem.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import { arrayToCsvFormat } from "common/helpers";
import { downloadBlobFile } from "common/helpers";
import Loader from "components/Loader/Loader.js";
import { fetchRequest } from "common/service";

const useStyles = makeStyles(styles);

const today = moment();

const disableFutureDt = (current) => current.isBefore(today);

const columns = [
  { id: "ownerName", label: "Resident Name", minWidth: 130, sort: false,},
  { id: "FriendlyNameD", label: "Friendly Name", minWidth: 150, sort: true,},
  { id: "DevidDevhealth", label: "Dev Id", minWidth: 130, sort: true,},
  { id: "ErrorType", label: "Error Type", minWidth: 130, sort: true,},
  { id: "ErrorLog", label: "Error Text", minWidth: 130, sort: true,},
  { id: "Fwvers", label: "Fwvers", minWidth: 130, sort: true,},
  { id: "TimestampD", label: "Error Time", minWidth: 130, type: "date",sort: true},
];

export default function ErrorLogs() {
  const classes = useStyles();

  const { device } = useSelector((state) => ({device: state.device}));

  const [userInfo, setUserInfo] = useState({
    interval: "1 Hr",
    deviceId: "d36a4373-fbdc-44a3-8c96-4bb920041e40",
    friendlyName: "all",
    intervalStartTime: new Date(),
    supplierId: "cd5dc314-6e25-48a8-9d47-9e574b8fe3a0",
  });
  const [rowsPerPage, setRowsPerPage] = useState(PAGINATION_DETAILS.pageSize);
  const [currentSearchResult, setCurrentSearchResult] = useState({});
  const [page, setPage] = useState(PAGINATION_DETAILS.pageNumber);
  const [refreshData, setRefreshData] = useState(Date.now());
  const [order, setOrder] = useState("maxValueProvidedOn");
  const [toastColor, setToastColor] = useState('danger');
  const [toastStatus, setToastStatus] = useState(false);
  const [selectedAll, setSelectedAll] = useState(false);
  const [errorLogList, setErrorLogList] = useState({});
  const [toastMessage, setToastMessage] = useState('');
  const [filterData, setFilterData] = useState({});
  const [orderBy, setOrderBy] = useState("DESC");
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [selected, setSelected] = useState([]);

  const [deleteErrorLogData] = useComposeDispatcher(DELETE_ERROR_LOG_DATA_REQUEST);

  const createSortHandler = (property) => () => {
    const isAsc = order === `data.${property}.value` && orderBy === "ASC";
    setOrderBy(isAsc ? "DESC" : "ASC");
    setOrder(`data.${property}.value`);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setChecked(false);
    setSelected([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setSelected([]);
    setPage(0);
    setChecked(false);
    setRowsPerPage(+event.target.value);
  };

  const onSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = errorLogList?.content?.map((n) => n.deviceDataId);
      setSelected(newSelecteds);
      setChecked(event.target.checked);
      return;
    }
    setSelected([]);
    setChecked(false);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    newSelected.length === 0 && setChecked(false);
    setSelected(newSelected);
  };

  const isSelected = (deviceDataId) => selected.indexOf(deviceDataId) !== -1;

  const getErrorLogsList = async(type = "list") => {
    if(filterData.user) {
      setLoading(true);
      const endPoint = `${API_BASE_URL}/data/devicedata-advanced/owner?pageNumber=${page}&pageSize=${rowsPerPage}&sortBy=${order}&sortOrder=${orderBy}`;
      const payload = {
        "deviceCriteria":[{"key":"ErrorLog","operator":"IsSet","value":null}],
        "deviceDataModelId":"d36a4373-fbdc-44a3-8c96-4bb920041e40-dh",
        "devicePropertyCodes":null,
        "ownerFilter":{"users": filterData.user}
      }
      if(filterData.friendlyName && filterData.friendlyName !== "all") {
        payload.deviceCriteria.push({
          "key": "DevidDevhealth",
          "operator": "Equal",
          "value": filterData.friendlyName
        })
      }
      if(type === "csvDownload") {
        payload.rangeEndDateTime = currentSearchResult.rangeEndDateTime;
        payload.rangeStartDateTime = currentSearchResult.rangeStartDateTime;
      }
      const errorLogData = await fetchRequest("POST", endPoint, payload);
      setLoading(false);

      if(!errorLogData?.content?.length) {
        setToastStatus(true);
        setToastColor('danger');
        setToastMessage('Error fetching error logs');
        return false;
      }

      if(type === "csvDownload") {
        prepaerCSVData(errorLogData?.content || []);
        return false;
      }
      setErrorLogList(errorLogData || {});
      setRefreshData(Date.now());
    }
  }

  const handleApply = async (filterData) => {
    console.log(filterData);
    setPage(0);
    setSelectedAll(false);
    setChecked(false);
    setSelected([]);
    setFilterData(filterData);
  };

  const debounceTimerRef = useRef(null);

  useEffect(() => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      getErrorLogsList(filterData);
    }, 500);

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [filterData, rowsPerPage, page, order, orderBy]);

  const fetchCSVData = () => {
    if(currentSearchResult.rangeEndDateTime && currentSearchResult.rangeStartDateTime) {
      getErrorLogsList("csvDownload");
    }
  }

  const prepaerCSVData = (errorLogData) => {
    const headers = ['Resident Name', 'Friendly Name', 'Dev Id', 'Error Type', 'Error Text', 'Fwvers', 'Error Time'];
    let csvFile = `error-logs.csv`;
    const csvData = errorLogData.map((item) => {
      return {
        'Resident_Name': item?.ownerName,
        'Friendly_Name': item?.data?.FriendlyNameD?.value,
        'Dev_Id': item?.data?.DevidDevhealth?.value,
        'Error_Type': item?.data?.ErrorType?.value,
        'Error_Text': item?.data?.ErrorLog?.value,
        'Fwvers': item?.data?.Fwvers?.value,
        'Error_Time': moment(item?.data?.TimestampD?.value).add(30, "minutes").format(CSV_DATE_FORMAT),
      }
    });

    /* let userTimeZone = timezones.find(
      (time) => time.value === deviceData.macIdObj[val.data.DevidDevhealth.value]
    )
    if (userTimeZone && userTimeZone.utc && userTimeZone.utc.length > 0) {
      timeProvided = momentTz
        .utc(val.data.TimestampD.valueProvidedOn)
        .tz(userTimeZone.utc[0])
        .format("MM/DD/YYYY hh:mm a")
    } */
    downloadBlobFile(arrayToCsvFormat(csvData, headers), csvFile, "text/csv;charset=utf-8;");
    setToastStatus(true);
    setToastColor('success')
    setToastMessage('Error log file downloaded successfully');
  }

  return (
    <>
      <NewFiltersBox onApply={handleApply} />
      <GridContainer key={refreshData}>
        {errorLogList?.content?.length > 0 && (
          <GridItem xs={12}>
            <Card>
              <CardHeader color="danger" icon>
                <CardIcon color="danger">
                  <List />
                </CardIcon>
                {
                  errorLogList?.content?.length > 0 && (
                    <Box style={{ float: "right" }}>
                      <GridContainer>
                        <GridItem xs={4} sm={4} md={4}>
                          <Box className={classes.cardIconTitle}>
                            <InputLabel style={{ fontSize: "12px" }}> Start Time </InputLabel>
                            <Datetime
                              isValidDate={disableFutureDt}
                              closeOnSelect={true}
                              value={currentSearchResult.rangeStartDateTime}
                              onChange={(val) => {
                                setCurrentSearchResult({...currentSearchResult, rangeStartDateTime: moment(val).format("YYYY-MM-DDTHH:mm:ss")});
                              }}
                            />
                          </Box>
                        </GridItem>
                        <GridItem xs={4} sm={4} md={4}>
                          <Box className={classes.cardIconTitle}>
                            <InputLabel style={{ fontSize: "12px" }}> End Time </InputLabel>
                            <Datetime
                              isValidDate={currentSearchResult.rangeStartDateTime ? (current) => current.isAfter(currentSearchResult.rangeStartDateTime) : disableFutureDt}
                              closeOnSelect={true}
                              value={currentSearchResult.rangeEndDateTime}
                              onChange={(val) => {
                                setCurrentSearchResult({...currentSearchResult, rangeEndDateTime: moment(val).format("YYYY-MM-DDTHH:mm:ss")});
                              }}
                            />
                          </Box>
                        </GridItem>
                        <GridItem xs={4} sm={4} md={4}>
                          <Box className={classes.cardIconTitle} style={{ float: "right" }}>
                            <Button color="primary" disabled={!currentSearchResult.rangeStartDateTime || !currentSearchResult.rangeEndDateTime} onClick={fetchCSVData}>Export to CSV</Button>
                          </Box>
                        </GridItem>
                      </GridContainer>
                    </Box>
                  )
                }
              </CardHeader>
              <CardBody>
                {selected.length > 0 && (
                  <Toolbar
                    style={{
                      color: "#fd0808",
                      fontSize: "16px",
                      backgroundColor: lighten("#fd0808", 0.85),
                    }}
                  >
                    <Grid container>
                      <Grid
                        item
                        xs={10}
                        style={{
                          margin: "auto",
                        }}
                      >
                        <Typography
                          className={classes.title}
                          color="#fd0808"
                          variant="subtitle1"
                          component="div"
                        >
                          You have selected all {selectedAll ? errorLogList.totalElements : selected.length} records.{" "}
                          {errorLogList.totalElements > selected.length && (
                            <Link color="#fd0808" onClick={
                              () => {
                                const currentStatus = selectedAll ? false : true;
                                setSelectedAll(currentStatus);
                              }
                            }>
                              {selectedAll ? `Unselect all` : `Select all`} {errorLogList.totalElements} records
                            </Link>
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Button
                          variant="outlined"
                          color="danger"
                          onClick={() => {
                            if (selectedAll) {
                              deleteErrorLogData({
                                deviceDataModelId: "d36a4373-fbdc-44a3-8c96-4bb920041e40-dh",
                                userIds: [userInfo.userId],
                                filter: {payload: { pageNumber: page, pageSize: rowsPerPage, sortBy: "maxValueProvidedOn", sortOrder: "DESC" }, data: filterData },
                              });
                            } else {
                              deleteErrorLogData({
                                deviceDataModelId: "d36a4373-fbdc-44a3-8c96-4bb920041e40-dh", deviceDataIds: selected,
                                filter: {payload: { pageNumber: page, pageSize: rowsPerPage, sortBy: "maxValueProvidedOn", sortOrder: "DESC"}, data: filterData},
                              });
                            }
                            setSelected([]);
                          }}
                        >
                          Confirm Delete
                        </Button>
                      </Grid>
                    </Grid>
                  </Toolbar>
                )}
                <TableContainer className={classes.container}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            inputProps={{ "aria-label": "select all" }}
                            indeterminate={
                              selected.length > 0 &&
                              selected.length < errorLogList.totalElements
                            }
                            checked={checked}
                            onChange={onSelectAllClick}
                          />
                        </TableCell>
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              maxWidth: column.minWidth,
                              minWidth: column.minWidth,
                            }}
                          >
                            {column.sort ? (
                              <TableSortLabel
                                style={{
                                  maxWidth: column.minWidth,
                                  minWidth: column.minWidth,
                                }}
                                active={orderBy === column.id}
                                direction={
                                  orderBy === column.id
                                    ? order.toLowerCase()
                                    : "asc"
                                }
                                onClick={createSortHandler(column.id)}
                              >
                                <Typography>{column.label}</Typography>
                              </TableSortLabel>
                            ) : (
                              <Typography>{column.label}</Typography>
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {errorLogList.totalElements === 0 && (
                        <TableRow>
                          <TableCell align="center" colSpan="7">
                            No records found
                          </TableCell>
                        </TableRow>
                      )}
                      {errorLogList?.content?.map((row, index) => {
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow hover role="checkbox" tabIndex={-1} key={index + "" + row.userId}>
                            {columns.map((column, cIndex) => {
                              let value = row?.data?.[column.id]?.value || row?.[column.id] || "";
                              if (column.type === "date") {
                                /* let userTimeZone = timezones.find((time) => time.value === row?.owner?.timeZone)
                                if (userTimeZone && userTimeZone.utc && userTimeZone.utc.length > 0) {
                                  value = momentTz.utc(row?.data?.TimestampD.valueProvidedOn).tz(userTimeZone?.utc?.[0]).format("MM/DD/YYYY hh:mm a")
                                } */
                                value = moment(row?.data?.[column.id]?.value).add(30, "minutes").format("MM/DD/YYYY hh:mm a");
                              }
                              let errorStyle = "#000000";
                              if (column.id === "errorType") {
                                if (value.toLowerCase().trim() === "w") {
                                  errorStyle = "orange";
                                  value = "Warning";
                                } else if (value.toLowerCase().trim() === "e") {
                                  errorStyle = "red";
                                  value = "Error";
                                } else if (value.toLowerCase().trim() === "l") {
                                  value = "Log";
                                }
                              }
                              if (column.id === "errorText") {
                                if (
                                  row["errorType"].toLowerCase().trim() === "w"
                                ) {
                                  errorStyle = "orange";
                                } else if (
                                  row["errorType"].toLowerCase().trim() === "e"
                                ) {
                                  errorStyle = "red";
                                }
                              }
                              return (
                                <>
                                  {cIndex === 0 && (
                                    <TableCell padding="checkbox">
                                      <Checkbox
                                        onChange={(event) =>handleClick(event, row.deviceDataId)}
                                        checked={isSelected(row.deviceDataId)}
                                        inputProps={{"aria-labelledby": labelId}}
                                      />
                                    </TableCell>
                                  )}
                                  <TableCell style={{color: errorStyle}} key={column.id} align={column.align}>
                                    {column.id !== "action" && column.format && typeof value === "number" ? column.format(value) : value}
                                  </TableCell>
                                </>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={PAGE_SIZES}
                  component="div"
                  count={errorLogList.totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
                {alert}
              </CardBody>
            </Card>
          </GridItem>
        )}
      </GridContainer>
      <Loader status={device.loading || device.loadingData || loading} />
      <Snackbar
        place="tr"
        color={toastColor}
        icon={AddAlert}
        message={toastMessage}
        open={toastStatus}
        closeNotification={() => {
          setToastStatus(false)
          setToastMessage('')
        }}
      />
    </>
  );
}
